import { Button, Flex, Image, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const ProductBox = styled(Flex)`
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.grey[10]};
  flex-direction: column;
  padding: 8px;
`

export const ProductImage = styled(Image)`
  width: 150px;
  ${(props) => props.theme.mediaQueries.tablet`
    width: 200px;
  `}
`

export const ProductTitle = styled(Typography)`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  font-size: 18px;
  height: 22px;
  line-height: 22px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) => props.theme.mediaQueries.tablet`
    margin-top: 8px;
    padding-left: 8px;
    padding-right: 8px;
  `}
`

export const ProductPrice = styled(Typography).attrs((props) => ({
  fontSize: "12px",
  fontWeight: "300",
  letterSpacing: "-0.02em",
  lineHeight: "14px",
  mb: "20px",
  ...props,
}))`
  s {
    font-weight: 500;
  }

  span {
    color: ${(props) => props.theme.colors.sale};
    font-weight: 500;
  }
`

export const SecondaryBtn = styled(Button).attrs({
  outline: "primary",
})`
  border-radius: 5px;
  color: ${(props) => props.theme.colors.primary};
  height: 48px;
  padding-left: 48px;
  padding-right: 48px;
  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`
